import { Dispatch } from 'redux';
import { IAppState } from 'config/redux/reducers';

import EApiMiddlewareMethod from 'config/redux/middlewares/api.middleware.enum';
import { AVAILABLE_PROMOTION_LIST_URL } from 'pages/Checkout/constants/apis.constant';
import AVAILABLE_PROMOTION_LIST from './AvailablePromotions.type';
import { getSelectedCardBin } from '../../Payment/helpers/payment.helpers';

export const appliedCouponApiSuccess = (payload: boolean) => ({
  type: AVAILABLE_PROMOTION_LIST.APPLIED_COUPON_API_SUCCESS,
  payload,
});

export const fetchAvailablePromotions = (voucherId: string = '') => (
  dispatch: Dispatch,
  getState: () => IAppState
) => {
  const {
    checkout: { payment: { paymentDetails = {} } = {} } = {},
    cart: { cartData: { subTotal = { value: 0 }, isNewUser = false } = {} } = {},
  } = getState();
  const binCode = getSelectedCardBin(paymentDetails);
  dispatch({
    type: AVAILABLE_PROMOTION_LIST.FETCH,
    payload: {
      method: EApiMiddlewareMethod.POST,
      apiVersion: 3,
      url: AVAILABLE_PROMOTION_LIST_URL,
      data: {
        subtotal: subTotal && subTotal.value,
        bin: binCode,
        isNewUser,
      },
      params: {
        appliedCode: voucherId,
        notab: true,
      },
    },
  });
};
